export const POLICY_FILTER_LABEL = "Policy status";
export const POLICY_FILTER_OPTION = "In policy only";
